export class RemoteAccessUser {
    constructor(public Id: number, public Name: string) {
    }
}